// The one password rule for every screen that sets a password (the APIs check
// the same, utils/passwordPolicy.js there): 8 to 50 characters, letters and
// numbers, no spaces. Use with <Input.Password maxLength={PASSWORD_MAX} />.

export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 50;
export const PASSWORD_PATTERN = /^(?=.*[A-Za-z])(?=.*[0-9])\S+$/;

export const PASSWORD_MESSAGES = {
  required: "Please enter the password.",
  min: "Password must be at least 8 characters.",
  pattern: "Password must contain letters and numbers, and no spaces.",
  confirmRequired: "Please confirm the password.",
  mismatch: "The passwords do not match.",
};

export const PASSWORD_HINT = "At least 8 characters, with letters and numbers, and no spaces.";

// rules for a password field; required is false where it may be left empty (e.g. keep the current password)
export const passwordRules = (required = true) => [
  ...(required ? [{ required: true, message: PASSWORD_MESSAGES.required }] : []),
  { min: PASSWORD_MIN, message: PASSWORD_MESSAGES.min },
  { pattern: PASSWORD_PATTERN, message: PASSWORD_MESSAGES.pattern },
];

// rules for the confirm field of passwordField; it is required when a password was typed
export const confirmPasswordRules = (passwordField = "password") => [
  ({ getFieldValue }) => ({
    validator(_, value) {
      const password = getFieldValue(passwordField);
      if (!password && !value) return Promise.resolve();
      if (!value) return Promise.reject(new Error(PASSWORD_MESSAGES.confirmRequired));
      if (value !== password) return Promise.reject(new Error(PASSWORD_MESSAGES.mismatch));
      return Promise.resolve();
    },
  }),
];

// the first problem with a password, or null (for forms that do not use antd rules)
export const passwordProblem = (value) => {
  const password = value || "";
  if (!password) return PASSWORD_MESSAGES.required;
  if (password.length < PASSWORD_MIN) return PASSWORD_MESSAGES.min;
  if (!PASSWORD_PATTERN.test(password)) return PASSWORD_MESSAGES.pattern;
  return null;
};
